import CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy from './CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy'

export default function CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy() {}

CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy.prototype = new CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy();

CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy.prototype.init = function({timeFormat, showSpentTime, showAverageRates, showOthers}) {
    CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.init.call(
        this,
        {
            timeFormat,
            showSpentTime,
            showAverageRates,
            showOthers,
        }
    )
    return this
}

CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy.prototype.isShowRatesForTopLevel = function () {
    return this.showAverageRates;
};

CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy.prototype.getTopLevelNameKey = function () {
    return "user.group";
};

CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy.prototype.getTopLevelHeaderCellClassName = function () {
    return "userGroup " + ( this.showSpentTime ? "darkHeaderCell" : "darkGreenHeaderCell" );
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/cost/CostHTMLPreviewTwoLevelsHeaderGroupsOnlyColumnsStrategy.js